module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Z. Hobson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Laura Z. Hobson (1900–1986) was an American novelist and short story writer. The daughter of Jewish immigrants, she is best known for her novels "), _c('i', [_vm._v("Gentleman’s Agreement")]), _vm._v(" (1947), which deals with anti-Semitism in postwar America, and "), _c('i', [_vm._v("Consenting Adult")]), _vm._v(" (1975), about a mother coming to terms with her son’s homosexuality, which was based upon her own experiences with her own son. Hobson died in New York City in 1986. "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12lHpYR/cover.jpg?1733151293352",
      "alt": "This image is the cover for the book Consenting Adult"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Consenting Adult\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the shifting social landscape of America in the 1960s, a mother struggles to understand—and accept—her son’s homosexuality"), _c('br'), _c('br')]), _vm._v("Tessa Lynn considers herself independent and progressive, a liberated woman of the 1960s. And yet, when she receives a letter from her youngest son, Jeff, informing her that he is gay, Tessa is distraught. At a time when homosexuality is regarded as a mental illness, she struggles with how best to be a parent to a gay son—and how to protect her family from the prejudices of the era.Elegant and subtly drawn, "), _c('i', [_vm._v("Consenting Adult")]), _vm._v(" is a stunning tribute to familial bonds, and a sympathetic portrait of a mother whose best intentions are often clouded by the stereotypes of her time.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0